import { Outlet } from 'react-router-dom';

import { PageSeo } from '@/seo';

import { AppHeader } from './components/AppHeader';
import { ClientMobileNav } from './components/ClientMobileNav';

/** Chrome for the client hub: top bar plus a mobile bottom bar. */
export const ClientHubLayout = () => (
  <div className="flex min-h-screen flex-col bg-gray-50 font-sans">
    <PageSeo page="client" />
    <AppHeader audience="client" />

    <main className="flex-1 bg-white pb-24 sm:bg-transparent md:pb-12">
      <Outlet />
    </main>

    <ClientMobileNav />
  </div>
);
